import {Language, Platform} from "@variocube/app-api";
import {AbstractApp} from "@variocube/app-common";
import icon from "./icon.svg";
import * as React from "react";
import {Component} from "react";
import {render} from "react-dom";

export default class Dx7SynthApp extends AbstractApp {

    constructor(platform:Platform) {
        super(platform, icon, '#843576', [Language.EN]);
        this.name = "DX7 Synth";
        this.description = "Play the virtual DX7 synthesizer";
        this.updateLauncherItems();
    }

    render(root: Element) {
        render(<HomeScreen/>, root);
    }

}

class HomeScreen extends Component {
    render() {
        return (
            <div id="dx7-synth-app">
                <iframe src="" style={{ width:"100%", height:"100%"}} />
            </div>
        )
    }
}

